import api from './api';

export const getPaidSaas = (page, params) => {
  return api.get('admin/PaidSaas', { params: { page: page, limit: 5, ...params } });
};

export const updatePaidSaas = (paidSaasId, dataForm) => {
  return api.put(`admin/paidsaas/${paidSaasId}`, { dataForm });
};

export const deletePaidSaas = (paidSaasId) => {
  return api.delete(`admin/paidsaas/${paidSaasId}`);
};

export const refreshStatusByStripe = (paidSaasId) => {
  return api.post(`admin/paidsaas/${paidSaasId}/refresh`);
};
